import countryCodesList from 'country-codes-list';
const flagEmojiForCountryCode = (countryCode) => countryCode
    .toUpperCase()
    .replace(/[A-Z]/g, (letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)));
export const allCountryCodes = countryCodesList
    .all()
    .map(({ countryCallingCode, countryCode, countryNameLocal }) => ({
    label: `+${countryCallingCode} (${countryCode})`,
    value: `+${countryCallingCode}`,
    countryCode,
    countryName: countryNameLocal,
    callingCode: countryCallingCode,
    flag: flagEmojiForCountryCode(countryCode),
}));
export const countryCodes = allCountryCodes.filter(({ value }, index) => allCountryCodes.findIndex((county) => county.value === value) === index);
export const phoneCountryCodes = allCountryCodes.map(({ callingCode, countryCode, countryName, flag, value }) => ({
    value,
    callingCode,
    countryCode,
    countryName,
    flag,
    label: `${flag} ${countryName} +${callingCode}`,
    shortLabel: `${flag} +${callingCode}`,
}));
export const countries = allCountryCodes.map(({ countryName }) => ({
    label: countryName,
    value: countryName,
}));
export const emailRegex = /^\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,3})+$/;
export const contactMask = '00-000-0000';
export const contactPlaceHolder = '70-000-0000';
export const contactRegex = /^\+\d{1,3} \d{3}-\d{3}-\d{4}$/;
export const initialTitles = [
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Mrs.', label: 'Mrs.' },
    { value: 'Ms.', label: 'Ms.' },
    { value: 'Dr.', label: 'Dr.' },
    { value: 'Prof.', label: 'Prof.' },
    { value: 'Rev.', label: 'Rev.' },
    { value: 'Sir', label: 'Sir' },
    { value: 'Lady', label: 'Lady' },
    { value: 'Lord', label: 'Lord' },
];
//# sourceMappingURL=data-utils-constants.js.map